@use "~theme/typography";
@use "~theme/breakpoints";

.header {
  @include typography.body-semibold;
  text-align: center;
  margin-top: 0;
  margin-bottom: 24px;
}

.body {
  @include typography.body;
  text-align: center;
  margin-bottom: 28px;
}

.buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;

  @include breakpoints.desktop {
    display: flex;
    flex-direction: row;
  }

  > button {
    flex: 1;
  }

  > button:last-child {
    margin-right: inherit;
  }
}
